import React, { FC, useEffect, useState } from 'react';
import {Card, Table, Row, Col, Alert} from 'antd';
import { ICmsTableProps } from './index.type';
import './index.scss';
import { localize } from '../../helpers';
import { TablePaginationConfig } from 'antd/es/table/interface';
import BellIcon from 'icons/bell.svg';

const CmsTable: FC<ICmsTableProps> = ({
    type,
    lang,
    requireAuthorization,
    noResNumber,
    columns,
    resultCard,
    children,
    showResponseBlock = true,
    translations,
    givenTitle,
    pagination,
    additionalContentToResult,
    showNumbers,
    showDebt,
    total,
    ...props
}) => {
    const [page, setPage] = useState(pagination ? pagination.current : 1);

    useEffect(() => {
        setPage(pagination ? pagination.current : 1);
    }, [columns]);

    const fixedIdColumn = [
        {
            width: 100,
            title: '№',
            key: 'index',
            fixed: 'left',
            align: 'center',
            render: (text: any, record: any, index: number) => index + 1 + (page - 1) * 10,
        },
        ...columns,
    ];

    const handleTableChange = (pagination: TablePaginationConfig) => {
        setPage(pagination.current);

        if (typeof props.handlePageNumberChange === 'function') {
            props.handlePageNumberChange(pagination.current);
        }
    };

    return (
        <Row>
            {showResponseBlock && (
                <Col
                    md={24}
                    xs={24}
                    lg={24}
                    className="response"
                >
                    {noResNumber ? null : (
                        <>
                            <div className="response__title">
                                {(translations &&
                                    localize('print-form.search-results', translations)) ||
                                    givenTitle}
                            </div>
                            {total && total > 150 && (
                                <Alert
                                    message="Внимание!"
                                    description="По данным параметрам найдено более 150 записей. Показаны первые
                                    150. Уточните критерии поиска"
                                    type="warning"
                                    className="mb-3"
                                    showIcon
                                />
                            )}
                            <div className="response__total">
                                {props.dataSource && props.dataSource.length > 0 ? (
                                    <>
                                        {translations && localize('print-form.found', translations)}
                                        {' ' + (total || props.dataSource.length)}
                                        {additionalContentToResult}
                                    </>
                                ) : (
                                    localize('notification.no-data', translations)
                                )}
                            </div>
                        </>
                    )}

                    <Row gutter={[10, { md: 10 }]}>
                        {requireAuthorization ? (
                            <Col
                                md={6}
                                xs={24}
                                lg={6}
                            >
                                <BellIcon />
                                <div className="auth-block">
                                    {localize('fno-nz001-sm', translations)}{' '}
                                    <a
                                        className="auth"
                                        onClick={() =>
                                            open(
                                                '/site/ru/master/isna-portal-cms/pages/login?redirect=' +
                                                location.pathname,
                                                '_self'
                                            )
                                        }
                                    >
                                        {localize('login-sm', translations)}
                                    </a>
                                </div>
                            </Col>
                        ) : (
                            <Col
                                md={12}
                                xs={24}
                                lg={12}
                            >
                                <Card className="card mb-4">
                                    <Row gutter={[16, { md: 10 }]}>
                                        {resultCard && (
                                            <Col
                                                md={24}
                                                xs={24}
                                                lg={24}
                                                className="card__title"
                                            >
                                                {resultCard}
                                            </Col>
                                        )}

                                        {children}
                                    </Row>
                                </Card>
                            </Col>
                        )}
                    </Row>
                </Col>
            )}

            {showDebt && props.dataSource && props.dataSource.length > 0 && (
                <div>
                    <Col
                        md={24}
                        xs={24}
                        lg={24}
                        className="my-4 fs-6"
                    >
                        <p
                            style={{
                                fontWeight: 500,
                                fontSize: 18,
                            }}
                        >
                            {localize('debts-state-revenue-authorities-table', translations)}
                        </p>
                    </Col>
                </div>
            )}

            <Table
                {...props}
                className={type && `table-${type} ${props.className} mt-3`}
                rowKey={(record) => record && record.id}
                bordered
                columns={
                    showNumbers
                        ? fixedIdColumn.map((column) => ({
                              ...column,
                              align: 'center',
                          }))
                        : columns
                }
                onChange={handleTableChange}
                style={{
                    display: props.dataSource && props.dataSource.length === 0 ? 'none' : 'block',
                }}
                pagination={pagination}
            />
        </Row>
    );
};
export default CmsTable;
